import {Text, View} from 'native-base';
import React from 'react';

import {formatNumber} from 'utils/string';

export interface TransferRewardsCreditsItemProps {
  label: string;
  balance?: number;
  labelPrefix: string;
}

const TransferRewardsCreditsItem = (props: TransferRewardsCreditsItemProps) => {
  const {label, balance, labelPrefix} = props;

  return (
    <View>
      <Text color="paleSky">
        {labelPrefix}
        <Text fontWeight="bold">{label}</Text>
      </Text>
      <Text color="paleSky">
        Balance:{' '}
        <Text fontWeight="semibold">{formatNumber(Number(balance))}</Text>
      </Text>
    </View>
  );
};

export default TransferRewardsCreditsItem;
